import { render, staticRenderFns } from "./BaseAccounItem.vue?vue&type=template&id=1487de68&scoped=true&"
import script from "./BaseAccounItem.vue?vue&type=script&lang=js&"
export * from "./BaseAccounItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1487de68",
  null
  
)

export default component.exports